import React, { Component } from 'react';
import NumberFormatCustom from '../std/NumberFormatCustom';
import ContMessageI18N from '../../containers/ContMessageI18N';

class TestPartExchange extends Component {
	constructor(props) {
		super(props);
		this.theme = props.theme;
	}

	static getValuesFromProps({ partExchange }) {
		return {
			earlySettlement: partExchange?.earlySettlement ?? "",
			tradeIn: partExchange?.tradeIn ?? "",
			cashBack: partExchange?.cashBack ?? "",
			equity: partExchange?.equity ?? ""
		};
	}

	handleChangeGeneric = name => event => {
		const value = event.target.value || "";
		this.handleChange({ [name]: value });
	};

	handleChange(data) {
		const updatedExchange = {
			...TestPartExchange.getValuesFromProps(this.props),
			...data
		};

		Object.keys(updatedExchange).forEach(
			key => (updatedExchange[key] === "" || updatedExchange[key] === null)  
			&& delete updatedExchange[key]
		);

		this.props.onChangePartExchange(updatedExchange);
	}

	getLabel(fieldname, i18nKey) {
		return this.props.settings.isDeveloperView ? fieldname 
		: this.getMessage(i18nKey);
	}

	getMessage(i18nKey) {
		return <ContMessageI18N i18n={i18nKey} />;
	}

	renderInput(fieldName, i18nKey, value) {
		return (
			<div className="col-auto form-floating">
				<NumberFormatCustom
					id={fieldName}
					className="form-control"
					placeholder={this.getLabel(fieldName, i18nKey)}
					value={value}
					onChange={this.handleChangeGeneric(fieldName)}
				/>
				<label htmlFor={fieldName}>{this.getLabel(fieldName, i18nKey)}</label>
			</div>
		);
	}

	render() {
		const { earlySettlement, tradeIn, cashBack, equity } = TestPartExchange.getValuesFromProps(this.props);

		return (
			<div className="row shadow p-2">
				{this.renderInput('earlySettlement', 'partExchange.earlySettlement', earlySettlement)}
				{this.renderInput('tradeIn', 'partExchange.tradeIn', tradeIn)}
				{this.renderInput('cashBack', 'partExchange.cashBack', cashBack)}
				{this.renderInput('equity', 'partExchange.equity', equity)}
			</div>
		);
	}
}

export default TestPartExchange;
